import type { DeployEnv } from './app-env';

export const DEPLOY_ENV: DeployEnv = 'prod';
